




























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { ICurrentUser } from "@/types/current-user.model";
import { LoginError, LoginErrorCode } from "@/types/enums";
import { LOGIN } from "../../graphql/auth";
import {
  validateEmailField,
  validateRequiredField,
} from "../../utils/validators";
import {
  initializeCurrentActor,
  NoIdentitiesException,
  saveUserData,
} from "../../utils/auth";
import { ILogin } from "../../types/login.model";
import {
  CURRENT_USER_CLIENT,
  UPDATE_CURRENT_USER_CLIENT,
} from "../../graphql/user";
import RouteName from "../../router/name";
import { CONFIG } from "../../graphql/config";
import { IConfig } from "../../types/config.model";
import AuthProviders from "../../components/User/AuthProviders.vue";

@Component({
  apollo: {
    config: {
      query: CONFIG,
    },
    currentUser: {
      query: CURRENT_USER_CLIENT,
    },
  },
  components: {
    AuthProviders,
  },
  metaInfo() {
    return {
      title: this.$t("Login on Mobilizon!") as string,
      titleTemplate: "%s | Mobilizon",
      meta: [{ name: "robots", content: "noindex" }],
    };
  },
})
export default class Login extends Vue {
  @Prop({ type: String, required: false, default: "" }) email!: string;

  @Prop({ type: String, required: false, default: "" }) password!: string;

  LoginErrorCode = LoginErrorCode;

  LoginError = LoginError;

  errorCode: LoginErrorCode | null = null;

  config!: IConfig;

  currentUser!: ICurrentUser;

  RouteName = RouteName;

  credentials = {
    email: "",
    password: "",
  };

  errors: string[] = [];

  rules = {
    required: validateRequiredField,
    email: validateEmailField,
  };

  submitted = false;

  mounted(): void {
    this.credentials.email = this.email;
    this.credentials.password = this.password;

    const { query } = this.$route;
    this.errorCode = query.code as LoginErrorCode;
  }

  async loginAction(e: Event): Promise<Route | void> {
    e.preventDefault();
    if (this.submitted) {
      return;
    }

    this.errors = [];

    try {
      this.submitted = true;
      const { data } = await this.$apollo.mutate<{ login: ILogin }>({
        mutation: LOGIN,
        variables: {
          email: this.credentials.email,
          password: this.credentials.password,
        },
      });
      if (data == null) {
        throw new Error("Data is undefined");
      }

      saveUserData(data.login);
      await this.setupClientUserAndActors(data.login);

      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect as string);
        return;
      }
      if (window.localStorage) {
        window.localStorage.setItem("welcome-back", "yes");
      }
      this.$router.push({ name: RouteName.HOME });
      return;
    } catch (err: any) {
      this.submitted = false;
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach(({ message }: { message: string }) => {
          this.errors.push(message);
        });
      } else if (err.networkError) {
        this.errors.push(err.networkError.message);
      }
    }
  }

  private async setupClientUserAndActors(login: ILogin): Promise<void> {
    await this.$apollo.mutate({
      mutation: UPDATE_CURRENT_USER_CLIENT,
      variables: {
        id: login.user.id,
        email: this.credentials.email,
        isLoggedIn: true,
        role: login.user.role,
      },
    });
    try {
      await initializeCurrentActor(this.$apollo.provider.defaultClient);
    } catch (err: any) {
      if (err instanceof NoIdentitiesException) {
        await this.$router.push({
          name: RouteName.REGISTER_PROFILE,
          params: {
            email: this.currentUser.email,
            userAlreadyActivated: "true",
          },
        });
      }
    }
  }

  @Watch("currentUser")
  redirectToHomepageIfAlreadyLoggedIn(): Promise<Route> | void {
    if (this.currentUser.isLoggedIn) {
      return this.$router.push("/");
    }
  }

  get hasCaseWarning(): boolean {
    return this.credentials.email !== this.credentials.email.toLowerCase();
  }

  get caseWarningText(): string | undefined {
    if (this.hasCaseWarning) {
      return this.$t(
        "Emails usually don't contain capitals, make sure you haven't made a typo."
      ) as string;
    }
    return undefined;
  }

  get caseWarningType(): string | undefined {
    if (this.hasCaseWarning) {
      return "is-warning";
    }
    return undefined;
  }
}
